import React from 'react';
import dayjs from 'dayjs';
import { COMPANY_DETAILS } from '../../../../AppConstants';
import '../../assets/css/footer_legal.css';

const {
  LEGAL_NAME,
  COMPANY_NUMBER,
  REGISTERED_IN,
  STREET_ADDRESS,
  LOCALITY,
  POSTCODE,
  VAT_NUMBER,
} = COMPANY_DETAILS;

function FooterLegalBar() {
  return (
    <div className='sbf-legal display-flex-column' data-sbf-reveal>
      <p className='sbf-legal__copyright fs-13 gSemiBold'>
        © {dayjs().year()} {LEGAL_NAME}. All rights reserved.
      </p>
      <p className='sbf-legal__disclosure fs-13 gRegular'>
        {LEGAL_NAME} is a company registered in {REGISTERED_IN}, company number{' '}
        {COMPANY_NUMBER}. Registered office: {STREET_ADDRESS}, {LOCALITY}{' '}
        {POSTCODE}.{VAT_NUMBER && ` VAT number: ${VAT_NUMBER}.`}
      </p>
    </div>
  );
}

export default FooterLegalBar;
